module.exports = __webpack_public_path__ + "img/Carvalho.b1bdb80e.png";